import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import {
  apiActionResult,
  apiActions as commonApiActions,
  apiResourceActionCreator
} from '../../common';
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';
import getTeamSyncStatusConfig from './getTeamSyncStatus';

const actions = createActions({
  TASK: {
    TRIGGER_TEAM_SYNC: (businessId, businessTeamId) => ({
      businessId,
      businessTeamId
    }),
    API: {
      TRIGGER_TEAM_SYNC: apiResourceActionCreator('task')
    }
  }
});

export const apiAction = (authToken, businessId, businessTeamId) =>
  commonApiActions.authenticated.post(
    `${API_ENDPOINT}/business/${businessId}/team/${businessTeamId}/sync`,
    authToken,
    {},
    actions.task.api.triggerTeamSync
  );

/**
 * Saga worker that triggers a team-level task synchronization and
 * initiates the polling sequence for its status updates.
 */
function* triggerTeamSync(action) {
  const authToken = yield select(authTokenSelector);
  const { businessId, businessTeamId } = action.payload;

  yield put(apiAction(authToken, businessId, businessTeamId));
  yield apiActionResult(actions.task.api.triggerTeamSync);

  yield put(
    getTeamSyncStatusConfig.action.task.getTeamSyncStatus(
      businessId,
      businessTeamId,
      true
    )
  );
}

/**
 * Redux configuration mapping action creators, asynchronous sagas,
 * and state slice reducers for team task synchronization.
 */
const configuration = {
  name: 'triggerTeamSync',
  action: actions,
  sagas: triggerTeamSync,
  reducers: {
    request: (state) => ({
      ...state,
      isTriggeringTeamSync: true,
      is429Error: false
    }),
    success: (state) => ({
      ...state,
      isTriggeringTeamSync: false,
      is429Error: false
    }),
    failed: (state, action) => {
      const is429Error =
        action &&
        action.meta &&
        action.meta.response &&
        String(action.meta.response.status) === '429';

      return {
        ...state,
        isTriggeringTeamSync: false,
        teamSyncStatus: is429Error ? state.teamSyncStatus : 'FAILED',
        is429Error: is429Error
      };
    }
  }
};

export default configuration;



// WEBPACK FOOTER //
// ./src/state/modules/task/configurations/triggerTeamSync.js